module.exports = __webpack_public_path__ + "static/media/main_banner.f05ead92.mp4";